import React from "react";
import { Col, Divider, Row, Tabs } from "antd";
import styles from "@aspen/theme/Structured.module.less";
import { type IInjectProps } from "@aspen/model";
import { withRouter } from "next/router";
import {
  i18nUtil,
  reportEvent,
  saveComplianceTag,
  GA_EVENT_NAME,
  STRUCTURED_TYPES,
} from "@aspen/libs";
import { Disclaimer, Compliance, ModalCompliance } from "@aspen/ui";
import { StructuredTableWrapper, AccumulatorTab, TabLabel, SnowballTab } from "@aspen/widgets";

type IProps = IInjectProps;

interface IState {
  currentTab: string;
  showCompliance: boolean;
  tabItems: TTabItems[];
}
const intl = i18nUtil.t();
type TTabItems = { key: string; label: JSX.Element };
class Structured extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      currentTab: STRUCTURED_TYPES.dual,
      showCompliance: false,
      tabItems: [
        {
          key: STRUCTURED_TYPES.dual,
          label: (
            <TabLabel
              title="wallet.structural.dual.currency"
              tooltipDesc="structured.tab.tooltips"
            />
          ),
        },
        // 2025.07.31 雪球、累积期权入口隐藏：https://kikitrade.coding.net/p/aspen/requirements/issues/40662/detail
        // {
        //   key: STRUCTURED_TYPES.accumulator,
        //   label: (
        //     <TabLabel
        //       title="wallet.structural.accumulator"
        //       tooltipDesc="wallet.structural.accumulator.tooltips"
        //     />
        //   ),
        // },
        // {
        //   key: STRUCTURED_TYPES.snowball,
        //   label: (
        //     <TabLabel
        //       title="wallet.structural.snowball"
        //       tooltipDesc="wallet.structural.snowball.tooltips"
        //     />
        //   ),
        // },
      ],
    };
  }

  // 2025.08.04 雪球、累积期权入口隐藏：https://kikitrade.coding.net/p/aspen/requirements/issues/40662/detail
  // componentDidMount() {
  //   const defaultTab =
  //     this.props?.router?.query?.currentTab?.toString() ||
  //     (isClient && getQueryValue("currentTab")) ||
  //     STRUCTURED_TYPES.dual;
  //   this.setState({
  //     currentTab: defaultTab,
  //   });
  // }

  handleChangeTab = currentTab => {
    reportEvent({
      moduleName: GA_EVENT_NAME.structured.switchStructureList,
      detailParams: { tab: currentTab },
    });
    this.props.router.replace({ query: { currentTab } });
    this.setState({
      currentTab,
    });
  };
  render(): React.ReactNode {
    const { currentTab, showCompliance, tabItems } = this.state;
    return (
      <section className={`${styles.structured} customer`}>
        <div className="customerTop">
          <Row className="top">
            <Col span={24}>
              <p className="title">{intl["structured.location.structured"]}</p>
            </Col>
          </Row>
        </div>
        <Row className="section">
          <Col span={24}>
            <Tabs
              items={tabItems}
              onChange={this.handleChangeTab}
              className={styles.tab}
              activeKey={currentTab}
            />
            <div className={styles.list}>
              <div className={styles.flexibleContent}>
                {currentTab === STRUCTURED_TYPES.dual && <StructuredTableWrapper />}
                {currentTab === STRUCTURED_TYPES.accumulator && <AccumulatorTab />}
                {currentTab === STRUCTURED_TYPES.snowball && <SnowballTab />}
              </div>
            </div>
          </Col>
        </Row>
        <Compliance module="structured" />
        <Divider />
        <Disclaimer />
        {showCompliance ? (
          <ModalCompliance
            open={showCompliance}
            onConfirm={this._onComplianceOk}
            onHide={this._onComplianceCancel}
          />
        ) : undefined}
      </section>
    );
  }
  _showCompliance = (show: boolean) => {
    this.setState({ showCompliance: show });
  };
  _onComplianceOk = () => {
    const { router } = this.props;
    saveComplianceTag(router.pathname);
    this._showCompliance(false);
  };
  _onComplianceCancel = () => {
    const { router } = this.props;
    this._showCompliance(false);
    router.back();
  };
}

export const PageStructured = withRouter(Structured);
